///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { ChangeDetectorRef, Directive, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { GtthHistoryService } from '../../../project-view-panel/logical-topology/engine/history-service';
import { isDefined } from '@siklu/sui-lib/utils';

@Directive({
    selector: '[windeDisableFormControls]'
})
export class GtthDisableFormControlsDirective implements OnDestroy, OnChanges {
    @Input('windeDisableFormControls') editForm;
    private editableModeChanges: Subscription;
    private readonly formElement;

    constructor(
        el: ElementRef,
        private readonly changeDetector: ChangeDetectorRef,
        public readonly historyService: GtthHistoryService
    ) {
        this.formElement = el.nativeElement;
        this.editableModeChanges = this.historyService.editModeEnabledChangedSubject.subscribe((isModeEnabled: boolean) => {
            if (isModeEnabled) {
                this.enableFormControls();
            } else {
                this.disableFormControls();
            }
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.editForm?.currentValue) {
            this.editForm = changes.editForm.currentValue;
            if (this.historyService.isEditModeEnabled) {
                this.enableFormControls();
            } else {
                this.disableFormControls();
            }
        }
    }

    ngOnDestroy(): void {
        if (this.editableModeChanges) {
            this.editableModeChanges.unsubscribe();
            this.editableModeChanges = undefined;
        }
    }

    private disableFormControls(): void {
        if (!this.editForm?.disabled) {
            for (const editFormControlKey in this.editForm.controls) {
                if (isDefined(editFormControlKey)) {
                    this.editForm.get(editFormControlKey).disable();
                }
            }
            const btn = this.formElement.querySelector(`button[type="submit"]`);
            if (btn && !btn.hasAttribute('disabled')) {
                btn.setAttribute('disabled', 'disabled');
            }
            this.changeDetector.markForCheck();
        }
    }

    private enableFormControls(): void {
        if (this.editForm?.disabled) {
            for (const editFormControlKey in this.editForm.controls) {
                if (isDefined(editFormControlKey)) {
                    this.editForm.get(editFormControlKey).enable();
                }
            }
            const btn = this.formElement.querySelector(`button[type="submit"]`);
            if (btn.hasAttribute('disabled')) {
                btn.removeAttribute('disabled');
            }
            this.changeDetector.markForCheck();
        }
    }
}
